import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div>
            <div className='container mb-3'>
                <h2>Privacy Policy</h2>
                <p><strong>Effective Date:</strong> 26th October 2024</p>
                <h4 className='mt-3'>1. Introduction</h4>
                <p>At Monarchinstitute.in, we are committed to protecting your privacy. This policy outlines how we collect, use, and protect your personal information when you use our services.</p>
                <h4 className='mt-3'>2. Information We Collect</h4>
                <p>We may collect the following types of information:</p>
                <p><span className='fw-bold'>Personal Information: </span>Name, email address, phone number, and payment information.</p>
                <p><span className='fw-bold'>Usage Data: </span>Information on how you use our website and services, including IP addresses and browser types.</p>
                <p><span className='fw-bold'>Cookies: </span>We may use cookies to enhance user experience and analyze website traffic.</p>
                <h4 className='mt-3'>3. How We Use Your Information</h4>
                <p>We use your information for:<br></br>
                Providing and managing our services<br></br>
                Processing payments<br></br>
                Communicating with you regarding your account and services<br></br>
                Improving our website and services<br></br>
                Complying with legal obligations</p>
                <h4 className='mt-3'>4. Data Sharing and Disclosure</h4>
                <p>We do not sell or rent your personal information to third parties. We may share your information with:<br></br>
                Service providers who assist in our operations (e.g., payment processors)<br></br>
                Legal authorities if required by law</p>
                <h4 className='mt-3'>5. Data Security</h4>
                <p>We implement reasonable security measures to protect your information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is 100% secure.</p>
                <h4 className='mt-3'>6. User Rights</h4>
                <p>You have the right to:<br></br>
                Access your personal information<br></br>
                    Request correction of inaccurate data<br></br>
                    Request deletion of your information (subject to legal obligations)</p>
                <h4 className='mt-3'>7. Changes to This Privacy Policy</h4>
                <p>We may update this privacy policy from time to time. Changes will be posted on our website with an updated effective date.</p>
                <h4 className='mt-3'>8. Contact Us</h4>
                <p>If you have any questions regarding these Terms and Conditions, please contact us:
                    <br></br>
                    Email : <a>info@monarchinstitute.in</a><br></br>
                    Phone Number: 9136431685
                </p>
            </div>
        </div>
    )
}

export default PrivacyPolicy
